<template>
    <div>
      <Head title="Blocker keywords" />
      <h1 class="mb-8 text-3xl font-bold">Blocker chat keywords</h1>
      <div class="flex items-center justify-between mb-6">
            <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset" @update:model-value="update">
                <label class="block mt-4 text-gray-700">Language:</label>
                <select v-model="form.locale" class="form-select mt-1 w-full">
                    <option :value="null"/>
                    <option v-for="row in languages" :key="row.key" :value="row.key">{{ row.name }}</option>
                </select>
            </search-filter>
        <Link class="btn-indigo" href="/blocker-keywords/create">
          <span>Create</span>
          <span class="hidden md:inline">&nbsp;new keyword</span>
        </Link>
      </div>
      <div class="bg-white rounded-md shadow overflow-x-auto">
        <table class="w-full whitespace-nowrap">
          <tr class="text-left font-bold">
            <th class="pb-4 pt-6 px-6">Keyword</th>
            <th class="pb-4 pt-6 px-6">Tags</th>
            <th class="pb-4 pt-6 px-6">Auto Reponse</th>
            <th class="pb-4 pt-6 px-6">Language</th>
            <th class="pb-4 pt-6 px-6" colspan="2">CreatedAt</th>
          </tr>
          <tr v-for="row in keywords" :key="row.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
            <td class="border-t">
              <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`/blocker-keywords/${row.id}/edit`">
                {{ row.keyword }}
                <icon v-if="row.deleted_at" name="trash" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
              </Link>
            </td>
            <td class="border-t">
              <span class="bg-gray-100 text-gray-800 text-xs font-medium mr-2 px-2.5 py-0.5 rounded dark:bg-gray-700 dark:text-gray-300" v-for="(tag, index) in row.tags" :key="'tag' + index">
                {{ tag.name }}
              </span>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-6 py-4" :href="`/blocker-keywords/${row.id}/edit`" tabindex="-1">
                {{ row.responseMessage ? row.responseMessage.name : 'Not set' }}
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-6 py-4" :href="`/blocker-keywords/${row.id}/edit`" tabindex="-1">
                {{ row.locale?.toUpperCase() }}
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-6 py-4" :href="`/blocker-keywords/${row.id}/edit`" tabindex="-1">
                {{ row.created_at }}
              </Link>
            </td>
            <td class="w-px border-t">
              <Link class="flex items-center px-4" :href="`/blocker-keywords/${row.id}/edit`" tabindex="-1">
                <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
              </Link>
            </td>
          </tr>
          <tr v-if="keywords.length === 0">
            <td class="px-6 py-4 border-t" colspan="4">No keywords found.</td>
          </tr>
        </table>
      </div>
    </div>
  </template>
  
  <script>
  import { Head, Link } from '@inertiajs/vue3'
  import Icon from '@/Shared/Icon'
  import pickBy from 'lodash/pickBy'
  import Layout from '@/Shared/Layout'
  import throttle from 'lodash/throttle'
  import mapValues from 'lodash/mapValues'
  import SearchInput from '@/Shared/SearchInput'
  import SearchFilter from '@/Shared/SearchFilter'
  
  export default {
    components: {
      Head,
      Icon,
      Link,
      SearchInput,
      SearchFilter
    },
    layout: Layout,
    props: {
      filters: Object,
      keywords: Array,
    },
    data() {
      return {
        form: {
          search: this.filters.search
        },
        languages: [
          {key: 'de', name: 'DE'},
          {key: 'en', name: 'EN'}
        ],
      }
    },
    watch: {
      form: {
        deep: true,
        handler: throttle(function () {
          this.$inertia.get('/blocker-keywords', pickBy(this.form), { preserveState: true })
        }, 150),
      },
    },
    methods: {
      reset() {
        this.form = mapValues(this.form, () => null)
      },
    },
  }
  </script>
  